import { z } from '@customerio/hydra-validation';
import { MIN_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS, MAX_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS } from '../types';

export interface SupportFormData {
  goal: string;
  video: string;
  consentToAccess: boolean;
  daysLimit: number;
}

export const GOAL_PLACEHOLDER = 'I need help with...';

/** True when the goal value is empty or exactly the placeholder (used for validation and submit button state). */
export function isDefaultGoalText(value: string | null | undefined): boolean {
  const trimmed = (value ?? '').trim();
  return trimmed === '' || trimmed === GOAL_PLACEHOLDER.trim();
}

export const supportFormSchema = z
  .object({
    goal: z
      .string()
      .min(1, 'Please tell us about the problem')
      .refine((value) => value.trim().length > 0, {
        message: 'Please provide a description',
      })
      .refine((value) => value.trim() !== GOAL_PLACEHOLDER.trim(), {
        message: 'Please provide a description',
      }),
    video: z.union([z.literal(''), z.string().url('Please enter a valid URL (e.g., https://loom.com/...)')]),
    consentToAccess: z.boolean(),
    daysLimit: z.coerce.number(),
  })
  .refine(
    (data) => {
      // Only validate daysLimit if consent is granted
      if (!data.consentToAccess) return true;
      return (
        data.daysLimit >= MIN_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS &&
        data.daysLimit <= MAX_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS
      );
    },
    {
      message: `Access must be between ${MIN_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS} and ${MAX_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS} days`,
      path: ['daysLimit'],
    },
  );
